<template>
  <div class="background">
    <b-container md>
      <b-row class="hero text-center">
        <b-col>
          <h1 class="title">Worship With Us</h1>
          <router-link
            :to="{ name: 'contact'}"
            class="nav-link"
          >Sunday 10:00am &bull; 845 Brown School Rd &bull; Everyone welcome</router-link>
        </b-col>
      </b-row>
      <b-row class="welcome">
        <b-col md="6">
          <h4>Welcome to Faith Christian Church Evansville!</h4>
          <p>We would love to see you at Faith Christian Church Evansville! You will experience a welcoming body of believers, uplifting music, and a biblical message that applies to your life.</p>
          <p>Jerry Dean is the pastor of Faith Christian Church Evansville. Jerry is passionate about teaching God's Word in a way that is meaningful, practical, and motivational for today. He is also a talented musician and worship leader.</p>
          <p>Worship Services begin at 10am at our new location, 845 Brown School Rd. Anyone in need of prayer or encouragement or would like more information please feel free to contact us!</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
export default {};
</script>

<style lang="scss">
.background {
  background-image: url("../assets/cross-skyline.jpg");
  background-position: top;
  background-size: cover;
  color: #f8f9fa;

  .hero {
    overflow-y: auto;
    font-size: 22px;
    text-shadow: 2px 2px 7px #000;
    padding: 60px 0;

    .title {
      font-family: "Alex Brush", cursive;
      font-size: 80px;
      line-height: 80px;
    }
  }

  .welcome {
    padding: 10px 0 60px 10px;
    text-shadow: 2px 2px 7px #000;
  }
}
</style>